import { render, staticRenderFns } from "./PhotographicProductionCard.vue?vue&type=template&id=5426e770&scoped=true&"
import script from "./PhotographicProductionCard.vue?vue&type=script&lang=js&"
export * from "./PhotographicProductionCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5426e770",
  null
  
)

export default component.exports